import { HashLink } from "react-router-hash-link";
import "../styles/Services.scss";
import { Email, Package } from "../components";

export const Services = () => {
  return (
    <article id="services">
      <h5 className="trans">What We Offer</h5>
      <h1>Elevate your space with our services</h1>
      <p>
        Enhance your home or business with our expert glass services, tailored
        to meet your needs in North Georgia.
      </p>
      <div className="row">
        <Package />
        <Email />
      </div>
      <h2>
        Need Help Immediately?{" "}
        <HashLink to="#contact">
          <strong>Contact Us Now!</strong>
        </HashLink>
      </h2>
    </article>
  );
};
